// src/AuthContext.js

import { createContext, useContext } from "react";
import { useMsal } from "@azure/msal-react";

export const AuthContext = createContext();

let latestMsalInstance = null;
let latestAccounts = [];

export const AuthProvider = ({ children }) => {
  const { instance, accounts } = useMsal();
  // Keep latest references for non-React modules (e.g., axios interceptors)
  latestMsalInstance = instance;
  latestAccounts = accounts || [];

  return (
    <AuthContext.Provider value={{ instance, accounts }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export const getMsalAuth = () => ({ instance: latestMsalInstance, accounts: latestAccounts });
